import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { from } from 'rxjs/internal/observable/from';
import { Observable } from 'rxjs/internal/Observable';
import { TranslationRequest } from '../models/translations';

@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService implements TranslateLoader {
   
  constructor(private readonly httpClient: ApiHttpClient) { }

  getTranslation(translationId: string): Observable<any> {
    const request: TranslationRequest = { translationId: +translationId };
    var promise = this.httpClient.getJsonAsync<string>('Translations/Translation', request);
    return from(promise);
  }

  getSystemDefaultTranslationIdAsync() : Promise<any> {
    return this.httpClient.getJsonAsync<any>('Translations/SystemDefault');
  }

  getTranslationOptionsAsync(): Promise<ListOption<number>[]> {
    return this.httpClient.getJsonAsync<ListOption<number>[]>('Translations/TranslationOptions');
  }

  setUserTranslationAsync(translationId: number, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('Translations/SetUserTranslation', translationId, cancellationToken);
  }
}
